<!--ptw总结-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 40px; position: absolute; color: white; font-weight: bold; font-size: 16px; line-height: 40px; padding-left: 20px; text-align: left">
      Main Con Total Equipment
    </h1>
    <div class="total_e_container">
      <div class="inner">
        Total:
      </div>
      <div class="inner">
        {{ total_num.toLocaleString() }}
      </div>
    </div>
    <div v-if="dataNotNull" key="1" class="totalequipmentDiv"
         style="width: 330px; height: 140px; position: absolute; top: 70px">
      <div class="container1" style="height: 140px"></div>
    </div>
    <div v-else key="2"
         style="width: 330px; height: 140px; position: absolute; top: 70px; line-height: 140px; color: #6CF; font-size: 16px;">
      No Data !
    </div>
  </div>

</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id'],
  name: "totalequipment",
  data() {
    return {
      color: this.$store.state.color.chart_color,
      myChart: null,
      total_num: 0,
      name: "ptws",
      dataNotNull: true,
      data: null,
    }
  },

  methods: {
    init() {
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    getData(period) {
      var that = this
      let postData = {
        project_id: this.project_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token')
      }
      axios.post(this.$store.getters.getCmsServer + "DBEquipments", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        this.myChart.hideLoading()
        if (errNo == "0") {
          this.dataNotNull = true
          var result = resp.data.result;
          var types = that.analysisTypes(result)
        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })
    },
    analysisTypes(data) {
      var that = this
      var types = []
      var type_nos = []
      var ids = []
      var counts = []
      data.forEach((item, index) => {
        var index = ids.indexOf(item.primary_id)
        if (index < 0) {
          ids.push(item.primary_id)
          var type = item.type_no
          var type_index = type_nos.indexOf(type)
          if (type_index < 0) {
            type_nos.push(type)
            types.push(item.device_type_en)
            counts.push(1)
          } else {
            counts[type_index] += 1
          }
        }
      })
      that.total_num = ids.length
      that.myChart.setOption({
        yAxis: {
          data: types,
          axisLabel: {
            margin: 15,
            show: true,
            textStyle: {
              color: '#FFF',
              fontSize: 12
            },
            formatter: function (params) {
              // console.log(params.length)
              return params.substring(0, 10) + '\n' + params.substring(10, params.length)
            }
          },
        },
        series: [
          {
            data: counts,
          }
        ]
      })
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  mounted() {
    let that = this
    this.myChart = echarts.init(document.querySelector('.totalequipmentDiv .container1'))
    this.myChart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        textStyle: {
          fontSize: '16'
        }
      },
      dataZoom: [
        {
          show: true,
          realtime: true,
          yAxisIndex: [0],
          left: '95%',
          startValue: 0, // 从头开始。
          endValue: 2,  // 一次性展示5个。
          showDetail: false,
          zoomLock: true,
          width: '4%'
        }
      ],
      grid: {
        left: 90,
        top: 10,
        bottom: 10
      },
      xAxis: {
        type: 'value',
        show: false,
      },
      yAxis: {
        type: 'category',
        inverse: true,
        data: [],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#6CF'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          margin: 15,
          show: true,
          textStyle: {
            color: '#FFF',
            fontSize: 12
          },
          formatter: function (params) {
            // console.log(params.length)
            return params
          }
        },
        splitLine: {
          show: false
        }
      },
      series: [
        {
          data: [],
          type: 'bar',
          barWidth: '60%',
          label: {
            normal: {
              show: false,
              // formatter: '{b}'
            }
          },
          itemStyle: {
            normal: {
              color: function (params) {
                return that.color[params.dataIndex % 10]
              },
            }
          },
        }
      ]
    })
    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });
    this.getData('0')
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.total_e_container {
  left 20px
  top 40px
  position absolute
  text-align center
  overflow: hidden;
  height 30px
  font-size 16px
  color white
  text-align left
}

.inner {
  display inline
}
</style>



// WEBPACK FOOTER //
// src/components/manpower/totalequipment.vue